module.exports = __webpack_public_path__ + "images/emoji/fr.fbb25eefcf05b0a51e43.png";